import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    dataTableWithoutHeader: {
      '& .MuiToolbar-gutters & .': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      }
    },
    commercialName: {
      marginBottom: theme.spacing(1)
    },
    description: {
      color: '#828282'
    },
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    cardContent: {
      paddingTop: '0px !important'
    }
  })
